import { render, staticRenderFns } from "./patientMyList.vue?vue&type=template&id=67fd6ff8&scoped=true"
import script from "./patientMyList.vue?vue&type=script&lang=js"
export * from "./patientMyList.vue?vue&type=script&lang=js"
import style0 from "./patientMyList.vue?vue&type=style&index=0&id=67fd6ff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fd6ff8",
  null
  
)

export default component.exports